'use es6';

export const THEME_CONFIGURATION_FILES = new Set(['fields.json', 'theme.json']);
export const BLANK_THEME_NAME = 'blank';
export const BOILERPLATE_THEME_NAME = 'boilerplate';
export const THEME_NAME_MAP = {
  [BLANK_THEME_NAME]: BLANK_THEME_NAME,
  [BOILERPLATE_THEME_NAME]: '@hubspot/boilerplate'
};